import { render, staticRenderFns } from "./teamRecordList.vue?vue&type=template&id=9bd96e9a&scoped=true"
import script from "./teamRecordList.vue?vue&type=script&lang=js"
export * from "./teamRecordList.vue?vue&type=script&lang=js"
import style0 from "./teamRecordList.vue?vue&type=style&index=0&id=9bd96e9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd96e9a",
  null
  
)

export default component.exports